import { render } from "./TheModalDelete.vue?vue&type=template&id=4fc1d894&scoped=true"
import script from "./TheModalDelete.vue?vue&type=script&lang=js"
export * from "./TheModalDelete.vue?vue&type=script&lang=js"

import "./TheModalDelete.vue?vue&type=style&index=0&id=4fc1d894&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\astac\\OneDrive\\Рабочий стол\\twodolist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc1d894"]])

export default __exports__